export default __webpack_public_path__ + "static/4wd-07c10b9f043df24476796b63df6ccb1a.png";